var _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSidebarEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.04156,
    y: 0.44,
    width: 21.12,
    height: 21.12,
    rx: 10.56,
    fill: "#FBA622"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7102 10.1417L9.31779 14.5301H8.07059V13.2787L12.4589 8.89036L13.7102 10.1417ZM15.0742 8.50146C15.1508 8.57805 15.1508 8.70125 15.0742 8.77783L14.4673 9.38477L13.2159 8.1334L13.8228 7.52646C13.8994 7.44988 14.0226 7.44988 14.0992 7.52646L15.0742 8.50146Z",
    fill: "#F6FAFB",
    stroke: "#F6FAFB",
    strokeWidth: 0.44
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.04156,
    y: 0.44,
    width: 21.12,
    height: 21.12,
    rx: 10.56,
    stroke: "#FBA622",
    strokeWidth: 0.88
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarEdit);
export default __webpack_public_path__ + "static/media/sidebarEdit.dfe1105e442a72740beb23b29aa4b709.svg";
export { ForwardRef as ReactComponent };